// 
// Cart Items
// 

class CartItems extends HTMLElement {
  constructor() {
    super();

    this.cartPopup = document.querySelector("cart-popup");
    this.cartPopupItems = this.cartPopup.querySelector("cart-popup-items"),
    
    this.addEventListener("change", this.onChange.bind(this));
  }

  onChange(ev) {
    if (!ev.target.dataset.index) return

    this.cartPopupItems.updateQuantity(
      ev.target.dataset.index,
      ev.target.value,
      document.activeElement.getAttribute("name"),
      false
    );
  }
}

customElements.define('cart-items', CartItems);

// 
// Cart Popup
// 

class CartPopup extends HTMLElement {
  constructor() {
    super();

    this.dialog = this.closest("dialog");
    this.items = this.querySelector("cart-popup-items");
  }

  render(parsedState, showDialog = true) {
    this.lineItemId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      let newSection = this.getSectionElement(
        parsedState.sections[section.id],
        section.selector
      );
      newSection
        .querySelector(`[data-id='${this.lineItemId}']`)
        ?.classList.add("highlight");

      document
        .getElementById(section.parentId || section.id)
        .querySelector(section.selector)
        .replaceWith(newSection);
    });

    if (showDialog) {
      this.dialog.show();
      setTimeout(() => {
        this.dialog.close();
      }, window.durations.veryLong);
    }
  }

  getSectionsToRender() {
    let sections = [
      {
        id: "cart-popup",
        selector: "cart-popup",
      },
    ];
    let mainCartSection = document.querySelector("main-cart");
    if (mainCartSection) {
      sections.push({
        id: mainCartSection.dataset.sectionId,
        parentId: mainCartSection.closest(".shopify-section").id,
        selector: "main-cart",
      });
    }
    return sections;
  }

  getSectionElement(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector);
  }
}

customElements.define('cart-popup', CartPopup);

// 
// Cart Popup Items
// 

class CartPopupItems extends HTMLElement {
  constructor() {
    super();

    this.cartPopup = this.closest("cart-popup");
    this.cartPopup.items = this;
    this.updateCartItemCounts();
    this.scrollToHighlightedElement();

    this.debouncedOnChange = debounce((ev) => {
      this.onChange(ev);
    }, window.durations.short);

    this.addEventListener("change", this.debouncedOnChange.bind(this));
  }

  onChange(ev) {
    this.updateQuantity(
      ev.target.dataset.index,
      ev.target.value,
      document.activeElement.getAttribute("name")
    );
  }

  scrollToHighlightedElement() {
    this.querySelector(".highlight")?.scrollIntoView({ behavior: "smooth" });
  }

  updateCartItemCounts() {
    document.querySelectorAll("[data-cart-item-count]").forEach((el) => {
      el.dataset.cartItemCount = this.dataset.count;
      el.innerText = this.dataset.count;
    });
  }

  updateQuantity(line, quantity, name, showDialogAfterChange = true) {
    const body = JSON.stringify({
      line,
      quantity,
      sections: this.cartPopup
        .getSectionsToRender()
        .map((section) => section.id),
      sections_url: window.location.pathname,
    });

    fetch(routes.cart_change_url, {
      ...fetchConfig(),
      ...{
        body,
      },
    })
      .then((response) => response.json())
      .then((parsedState) => {
        this.cartPopup.render(parsedState, showDialogAfterChange);

        document
          .getElementById(`cart-popup-item-${line}`)
          ?.querySelector(`[name="${name}"]`)
          ?.focus();
      })
      .catch((e) => {
        console.error("CartPopupItems#updateQuantity", e);
      });
  }
}

customElements.define('cart-popup-items', CartPopupItems);

// 
// Cart Item Remove Button
// 

class CartItemRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.items = this.closest('cart-popup-items');

    this.addEventListener('click', (ev) => {
      if (!this.items) return
      
      ev.preventDefault();
      this.items.updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-item-remove-button', CartItemRemoveButton);